module.exports = __webpack_public_path__ + "img/arrow-right-red.92b34a68.svg";